import React, { Component } from 'react';
const unAuthMenu = (props) => {
    let spanTest = null;
    let spanVersion = null;
    let isFromLink = false;
    let strurlParams = "";
    let qp = ""
    let mob_Session_USERID = ""
    let mob_Session_BUSUNIT = ""
    let Token = ""
    let Password = ""
    /*[08/22/22 , PC_04]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
    const urlParams = window.location.search;
    if (urlParams.includes("?qp_mob")) {
        strurlParams = urlParams.toString()
        let StrURL = strurlParams.split("?qp_mob=")
        let DecodedQueryparams = StrURL[1].toString();
        qp = atob(DecodedQueryparams);
        let QueryParams = qp.split("&")
        mob_Session_USERID = QueryParams[0].replace("mob_Session_USERID=", "");
        mob_Session_BUSUNIT = QueryParams[1].replace("mob_Session_BUSUNIT=", "");
        Password = QueryParams[2].replace("Password=", "");
        Token = QueryParams[3].replace("Token=", "");
        if (mob_Session_USERID || mob_Session_BUSUNIT || Token) {
            isFromLink = true;
        }
    }
    if (localStorage.sessionTimeOutData) {
        let environmentDetails = JSON.parse(localStorage.sessionTimeOutData);
        if (environmentDetails) {
            if (environmentDetails.length > 0) {
                environmentDetails = environmentDetails[0];
                environmentDetails.lblTestVisible = environmentDetails.lblTestVisible.toLowerCase() == "true"
                spanTest = (environmentDetails.lblTestVisible ? <span className="alert-text-title">{environmentDetails.lblTest}</span> : null);
                spanVersion = (environmentDetails.lblTestVisible ? <span className="px-2">{environmentDetails.lblVersion}</span> : null);
            }
        }
    }


    return (
        <div>
            {!isFromLink ?
                <div className="fixed-top">
                    <nav className="navbar navbar-expand-lg navbar-light bg-dark-sdi-nav border-0 main-menu">
                        <a className="navbar-brand ml-2" > <img src="/Images/sdi-logo.png" className="sdi-logo" alt="SDI Logo" /> </a>
                    </nav>
                    {spanTest || spanTest ? <section className="breadcrumb-section">
                        <div className="alert-text float-right">
                            {spanTest}
                            {spanVersion}
                        </div>
                    </section> : null}
                </div> : null}
        </div>



    )
}
const UnAuthMenuComponent = unAuthMenu;
export default UnAuthMenuComponent;